














































































































































































































































































































































































































































































































































































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import InputNumber from "@/views/components/input/InputNumber.vue";
import { SeibiExtremeService } from "@/services/SeibiExtreme.service";
import { Utils } from "@/services/utils";
import { SeibiService } from "@/services/Seibi.service.ts";
import { MESSAGE } from "@/models/Message";
import { InspectCategory } from "@/models/InspectCategory";
import { InspectDescription } from "@/models/InspectDescription";
import { InspectCommentService } from "@/services/InspectComment.service";
import { NewSeibi } from "@/models/Seibi";
import { CommonService } from "@/services/Common.service";
import { InspectCondition } from "@/models/InspectCondition";
import ComponentWithGroupShaten from "@/views/components/ComponentWithGroupShaten";
import FilterSelectBox from "@/shared/mixins/FilterSelectBox";
import vuedraggable from "vuedraggable";
import { Getter } from "vuex-class";

@Component({
  components: { InputNumber, draggable: vuedraggable },
  mixins: [FilterSelectBox]
})
export default class SeibiWork extends ComponentWithGroupShaten {
  @Prop({ default: "" })
  title: string;
  utils = new Utils();
  seibiService = new SeibiService();
  service: SeibiExtremeService = new SeibiExtremeService();
  itemSizeSelected: number = 20;
  public itemSizes: any[] = [
    { label: "10件", value: 10 },
    { label: "20件", value: 20 },
    { label: "50件", value: 50 },
    { label: "100件", value: 100 }
  ];
  loading: boolean = false;
  kousuLabel = ["軽", "小型", "普通", "大型", "大型特殊", "その他"];
  showEditDialog = false;
  showKousuDialog = false;
  koukanMeyasuTime: number | null = null;
  workId: any = null;
  workKousuu: any = [];
  workNm: string = "";
  customWorkNm: string = "";
  editDialogSource: any = [];

  listSelected: any = [];
  workEditing: any = {};

  valTest = "test";
  group: any = null;
  summaryClass: any = null;

  extremeWorkList = [];
  currentData: any = [];
  // dataPageList: any = [];
  data: any = [];
  currentInspectData: any = {};
  currentTypeIndex: number = 0;
  currentCateIndex: number = 0;
  doGetDataAfterClose: boolean = false;
  hanyouSeibiVersion: any = 1;
  inspectCommentList: any = [];
  inspectCommentService: InspectCommentService = new InspectCommentService();
  tempCate: InspectCategory = {} as InspectCategory;
  tempInspect: InspectDescription = {} as InspectDescription;
  tempSeibi: NewSeibi = {} as NewSeibi;
  tempSubItem: any = {};
  tempInspectWork: any = {};

  showCateDialog = false;
  showInspectDialog = false;
  showSeibiDialog = false;

  commonService = new CommonService();

  // kbn for m_skn_inspect_condition
  kbnTitles = [
    { kbn: "skn_youto", listNm: "youtoList" },
    { kbn: "skn_kudou_houshiki", listNm: "kudouList" },
    { kbn: "skn_fuel_kbn", listNm: "fuelList" },
    { kbn: "skn_shift_kbn", listNm: "shiftList" },
    { kbn: "skn_brake", listNm: "brakeList" }
  ];

  jidoushaShubetsuList: any = [];
  youtoList: any = [];
  kudouList: any = [];
  fuelList: any = [];
  shiftList: any = [];
  brakeList: any = [];
  tempCondition: InspectCondition = {} as InspectCondition;
  selectedJidousha: number[] = [];

  kyotenDataList: any = [];
  versionList: any = [];
  loadingCd = false;

  isEdit: boolean = false;
  showConfirmDelete = false;
  jizenData: any = {};
  jizenOsusumeData: any = {};
  showConfirmDeleteJizen: boolean = false;
  tempJizenItem: any = {};
  timerReOrder: any = null;
  jizenVal: boolean = false;

  /** 2021-08-03 sh #7329 implements delete [START] */
  showConfirmDeleteMidCategory: boolean = false;
  showConfirmDeleteSubCategory: boolean = false;
  showConfirmDeleteInspection: boolean = false;

  tempMidCategory: any = {};
  tempSubCategory: any = {};
  tempInspection: any = {};
  isNeedDeleteJizen: boolean = false;
  /** 2021-08-03 sh #7329 implements delete [END] */

  workAdd: number = 0;
  isSubCate: boolean = false;
  showConfirmDeletExtremeWork: boolean = false;
  tempInspectSeibiLink: any = {};

  /** 2021-08-05 sh #7329 add loginTypeKbn to store for Admin check [START] */
  @Getter("isNotAdmin", { namespace: "AuthStore" })
  public isNotAdmin: boolean;
  /** 2021-08-05 sh #7329 add loginTypeKbn to store for Admin check [END] */
  showConfirmDeleteJizenAll: boolean = false;
  tempJizenItems: any[] = [];

  /** 2021-08-30 sh #7382 fix it does not add category. [START] */
  isEditCheckOsusume: boolean = false;
  /** 2021-08-30 sh #7382 fix it does not add category. [END] */

  created() {
    this.form = {
      kyotenCd: "",
      groupCd: "",
      shatenCd: "",
      version: ""
    };

    this.initTempInspect();
    this.initTempSeibi();
    this.getExtremeWorks();
    this.getKbnList();
    this.getGroupDataList().then(res => {
      this.getShatenDataList().then(res2 => {
        this.getKyotenDataList().then(res3 => {
          if (res3 && res3.length > 0) {
            this.form.kyotenCd = localStorage.getItem("kyotenCd");
            this.getVersionList().then(() => {
              if (this.versionList.length === 1) {
                this.form.version = this.versionList[0].sknHanyouSeibiVersionId;
                this.hanyouSeibiVersion = this.form.version;
                this.getExtremeWorkLink();
              }
            });
          }
        });
      });
    });
    this.getJizenVal();
  }

  async getKyotenDataList() {
    this.form.version = "";
    this.versionList = [];
    const response = await this.commonService.getKyotenHasVersion(
      this.form.groupCd,
      this.form.shatenCd
    );
    if (response) {
      this.$set(this, "kyotenDataList", response);
    }
    if (this.kyotenDataList.length === 0) {
      this.form.kyotenCd = "";
      this.getVersionList();
    }
    return response;
  }

  async getGroupDataList() {
    const response = await this.accountService.getGroups();
    if (response && response.data) {
      this.$set(this, "groupDataList", response.data);
      this.form.groupCd = response.groupCd || "";
      this.form.shatenCd = response.shatenCd || "";
    }
  }

  async selectGroup1() {
    this.versionList = [];
    this.selectGroup();
  }

  async getVersionList() {
    const res = await this.commonService.getHanyouSeibiVersion(
      this.form.groupCd,
      this.form.shatenCd,
      this.form.kyotenCd
    );
    this.$set(this, "versionList", res);
  }

  selectKyoten() {
    this.getVersionList();
  }

  selectVersion() {
    this.hanyouSeibiVersion = this.form.version;
    this.getExtremeWorkLink();
  }

  renderFunc(h: any, option: any) {
    const s1 = h("span", option.workCd);
    const s2 = h("span", { attrs: { class: "worknm" } }, option.workNm);
    const s3 = h("span", { attrs: { class: "groupnm" } }, option.workGroupNm);
    const s4 = h("span", option.shuukeiKbn);
    const s5 = h(
      "span",
      { attrs: { class: "kouchin" } },
      this.utils.getNumberThousandSeparate(option.kouchinZn)
    );

    return h("div", { attrs: { class: "item", title: option.workNm } }, [
      s1,
      s2,
      s3,
      s4,
      s5
    ]);
  }

  async getExtremeWorks() {
    const { result } = await this.service.getExtremeWorks();
    if (result && result.data) {
      this.extremeWorkList = result.data;
    }
  }

  async getExtremeWorkLink() {
    /** 2021-08-03 sh #7329 implements delete [START] */
    this.currentData = [];
    /** 2021-08-03 sh #7329 implements delete [END] */
    this.loading = true;
    const { result } = await this.service.getExtremeWorkLink(
      this.hanyouSeibiVersion
    );
    this.loading = false;
    if (result && result.data) {
      this.data = result.data;
      let jizenCate = [];
      if (this.data[3].categories && this.data[3].categories.length > 0) {
        jizenCate = this.data[3].categories.filter((elm: any) => (elm.isOsusume == null || elm.isOsusume != 1));
      }
      this.jizenData = {
        id: this.data[3].id
        , sknInspectCategoryId: this.data[3].sknInspectCategoryId
        , sknInspectCategoryNm: this.data[3].sknInspectCategoryNm
        , categories: jizenCate
      };
      let jizenOsusumeCate = [];
      if (this.data[3].categories && this.data[3].categories.length > 0) {
        jizenOsusumeCate = this.data[3].categories.filter((elm: any) => (elm.isOsusume&& elm.isOsusume == 1));
      }
      this.jizenOsusumeData = {
        id: this.data[3].id
        , sknInspectCategoryId: this.data[3].sknInspectCategoryId
        , sknInspectCategoryNm: this.data[3].sknInspectCategoryNm
        , categories: jizenOsusumeCate
      };
      this.setData();
    }
  }

  setData() {
    if (this.data[this.currentTypeIndex]) {
      this.currentInspectData = this.data[this.currentTypeIndex];
      if (this.data[this.currentTypeIndex].categories[this.currentCateIndex]) {
        if (this.currentTypeIndex === 2) {
          this.currentData = [
            {
              inspectWorks: this.data[this.currentTypeIndex].categories[
                this.currentCateIndex
              ].shakenWork
              , isKingaku: this.data[this.currentTypeIndex].categories[this.currentCateIndex].kingakuZk != null
              , isJizen: (this.data[this.currentTypeIndex].categories[this.currentCateIndex].shakenWork
              && this.data[this.currentTypeIndex].categories[this.currentCateIndex].shakenWork.length > 0)
              ? this.data[this.currentTypeIndex].categories[this.currentCateIndex].shakenWork[0].jizenId != null: false
            }
          ];
        } else {
          this.currentData = this.data[this.currentTypeIndex].categories[
            this.currentCateIndex
          ].subItems;
          this.currentData = this.currentData.map((e: any) => {
            let inspectWorks = e.inspectWorks.map((item: any) => {
              return { ...item };
            });
            return { ...e, inspectWorks: inspectWorks
            , isOsusume: this.data[this.currentTypeIndex].categories[this.currentCateIndex].isOsusume };
          });
        }
      }
    } else {
      this.currentInspectData = {};
      this.currentData = [];
    }
  }

  changeInspectType() {
    this.currentCateIndex = 0;
    this.setData();
  }

  onCloseDialog() {
    this.workAdd = 0;
    this.isSubCate = false;
    this.showEditDialog = false;
  }

  onEdit(work: any) {
    this.showEditDialog = true;
    this.workEditing = work;
    if (work.extremeWork && work.extremeWork.length > 0) {
      this.listSelected = work.extremeWork.map((e: any) => e.workCd);
    } else {
      this.listSelected = [];
    }
  }

  onSave() {
    let extremeWorks: any = [];
    let deletedExtremeWorks: any = [];
    if (this.workEditing.extremeWork.length > 0) {
      deletedExtremeWorks = this.workEditing.extremeWork
        .filter(
          (extreme: any) => this.listSelected.indexOf(extreme.workCd) === -1
        )
        .map((e: any) => {
          return { workCd: e.workCd };
        });
    }
    if (this.listSelected.length > 0) {
      extremeWorks = this.extremeWorkList
        .filter(
          (extreme: any) => this.listSelected.indexOf(extreme.workCd) > -1
        )
        .map((e: any) => {
          return { workCd: e.workCd };
        });
    }

    let promiseSave = null;
    let promiseDel = null;
    if (extremeWorks.length > 0) {
      const obj: any = {
        shakenWorkId: this.workEditing.workId,
        sknHanyouSeibiVersionId: this.hanyouSeibiVersion, // 2022-11-21 sh #7846(BQR965) add version.
        extremeWorks
      };
      promiseSave = this.service.saveExtremeWorkLink(obj);
    }
    if (deletedExtremeWorks.length > 0) {
      const obj: any = {
        shakenWorkId: this.workEditing.workId,
        sknHanyouSeibiVersionId: this.hanyouSeibiVersion, // 2022-11-21 sh #7846(BQR965) add version.
        deletedExtremeWorks
      };
      promiseDel = this.service.deleteExtremeWorkLink(obj);
    }

    if (promiseSave && promiseDel) {
      Promise.all([promiseSave, promiseDel]).then((res: any) => {
        if (res && res.result && res.result.status == 200) {
          this.getExtremeWorkLink();
        } else {
          this.$message.error(MESSAGE.SystemError);
        }
      });
    } else {
      if (promiseSave) {
        promiseSave.then(res => {
          this.onAfterExtreme(res);
        });
      } else if (promiseDel) {
        promiseDel.then(res => {
          this.onAfterExtreme(res);
        });
      }
    }

    this.showEditDialog = false;
    /** 2023-01-23 sh #7846(BQR965) fix bug. add dummy option. [START] */
    this.workAdd=0;
    /** 2023-01-23 sh #7846(BQR965) fix bug. add dummy option. [END] */
  }

  openKousu(data: any) {
    this.showKousuDialog = true;
    this.doGetDataAfterClose = false;
    if (data.workKousuu && data.workKousuu.length > 0) {
      this.workKousuu = data.workKousuu;
      const list = this.jidoushaShubetsuList.map((e: any) => e.kbnKey);
      this.workKousuu.sort((a: any, b: any) => list.indexOf(a.jidoushaShubetsu) - list.indexOf(b.jidoushaShubetsu));
    } else {
      this.workKousuu = [
        { kousuu: 0, jidoushaShubetsu: 3, kouchinZn: null },
        { kousuu: 0, jidoushaShubetsu: 2, kouchinZn: null },
        { kousuu: 0, jidoushaShubetsu: 1, kouchinZn: null },
        { kousuu: 0, jidoushaShubetsu: 4, kouchinZn: null },
        { kousuu: 0, jidoushaShubetsu: 5, kouchinZn: null },
        { kousuu: 0, jidoushaShubetsu: 6, kouchinZn: null }
      ];
    }

    this.koukanMeyasuTime = data.koukanMeyasuTime;
    this.workId = data.workId;
    this.workEditing = data;

    if (data.isExtreme) {
      this.workNm = data.shakenWorkNm;
    } else {
      this.workNm = data.workNm;
    }
    this.customWorkNm = data.customWorkNm;
  }

  onAfterExtreme(res: any) {
    if ((res.result && res.result.status == 200) || res.status == 200) {
      this.getExtremeWorkLink();
    } else {
      this.$message.error("エラー");
    }
  }

  onSaveKousu() {
    this.doGetDataAfterClose = false;
    let arrPromise: any = [];
    if (this.workEditing.isExtreme) {
      const obj: any = {
        workCd: this.workEditing.workCd,
        koukanMeyasuTime: this.koukanMeyasuTime,
        seibiKousuuItem: this.workKousuu.map((e: any) => {
          return { kousuu: e.kousuu, jidoushaShubetsu: e.jidoushaShubetsu };
        })
      };
      arrPromise.push(this.service.saveExtremeKousuu(obj));
    } else {
      const obj: any = {
        sknInspectSeibiDetailId: this.workId,
        koukanMeyasuTime: this.koukanMeyasuTime,
        seibiKousuuItem: this.workKousuu
      };
      arrPromise.push(this.seibiService.editSeibi(obj));
    }
    if (this.customWorkNm) {
      let objName: any = {
        customWorkNm: this.customWorkNm
      };
      if (this.workEditing.isExtreme) {
        objName.workCd = this.workEditing.id;
      } else {
        objName.shakenWorkId = this.workEditing.id;
      }
      arrPromise.push(
        this.service.saveWorkName(objName, this.workEditing.isExtreme)
      );
    }
    Promise.all(arrPromise).then((res: any) => {
      let isOk = res.every((e: number) => e == 200);
      if (isOk) {
        this.getExtremeWorkLink();
      } else {
        this.$message.error("エラー");
      }
    });
    this.showKousuDialog = false;
    /** 2023-01-23 sh #7846(BQR965) fix bug. add dummy option. [START] */
    this.workAdd=0;
    /** 2023-01-23 sh #7846(BQR965) fix bug. add dummy option. [END] */
  }

  filterMethod(query: string, item: any) {
    return (
      item.shuukeiKbn.indexOf(query) > -1 ||
      item.shuukeiKbn.indexOf(query) > -1 ||
      item.workGroupNm.indexOf(query) > -1 ||
      item.workGroupNm.indexOf(this.utils.convertToJAHalfWidth(query)) > -1 ||
      item.workNm.indexOf(query) > -1 ||
      item.workNm.indexOf(this.utils.convertToJAHalfWidth(query)) > -1 ||
      item.workCd.indexOf(query) > -1
    );
  }

  mapShakenWork(work: any) {
    let extremeWork = [];
    if (work.extremeWork && work.extremeWork.length > 0) {
      let shakenWorkId = work.workId;
      extremeWork = work.extremeWork.map((extreme: any) => {
        const exWorkNm = extreme.customWorkNm
          ? `${extreme.customWorkNm} (${extreme.workNm})`
          : extreme.workNm;
        return {
          id: extreme.workCd,
          isWork: true,
          isExtreme: true,
          shakenWorkNm: work.workNm,
          label: extreme.workCd + " " + exWorkNm,
          shakenWorkId: shakenWorkId,
          ...extreme,
          children: extreme.buhins.map((buhin: any) => {
            return {
              id: buhin.buhinCd,
              label: buhin.buhinCd + " " + buhin.buhinNm
            };
          })
        };
      });
    }
    const shWorkNm = work.customWorkNm
      ? `${work.customWorkNm} (${work.workNm})`
      : work.workNm;
    return {
      ...work,
      id: work.workId,
      label: work.workCd + " " + shWorkNm,
      isWork: true,
      isExtreme: work.isExtreme == 1,
      isCanEdit: work.workCd != "" ? true : false,
      children: extremeWork
    };
  }

  mapTree(data: any) {
    if (this.currentTypeIndex === 2) {
      return [this.mapShakenWork(data)];
    }
    let works = [];
    if (data.shakenWork && data.shakenWork.length > 0) {
      works = data.shakenWork.map((work: any) => this.mapShakenWork(work));
    }
    return [
      {
        id: data.inspectCd,
        label: data.inspectCd + " " + data.inspectNm,
        isInspect: true,
        isCanDelete: (data.isCanDelete && data.inspectCd > 15000000) ? true : false, // 2021-08-03 sh mod
        children: works,
        sknHanyouSeibiVersion: data.sknHanyouSeibiVersion,  // 2021-08-03 sh add
        inspectId: data.id,                                 // 2021-08-03 sh add
        inspectCd: data.inspectCd                           // 2021-08-03 sh add
      }
    ];
  }

  deleteCustomName() {
    this.customWorkNm = "";
    let obj: any;
    if (this.workEditing.isExtreme) {
      obj = { workCd: this.workEditing.id };
    } else {
      obj = { shakenWorkId: this.workEditing.id };
    }
    this.service.deleteWorkName(obj, this.workEditing.isExtreme).then(res => {
      if (res != 200) {
        this.$message.error("エラー");
      } else {
        this.doGetDataAfterClose = true;
      }
    });
  }

  onCloseKousuuDialog() {
    if (this.doGetDataAfterClose) {
      this.getExtremeWorkLink();
    }
    /** 2023-01-23 sh #7846(BQR965) fix bug. add dummy option. [START] */
    this.showKousuDialog=false;
    this.workAdd=0;
    /** 2023-01-23 sh #7846(BQR965) fix bug. add dummy option. [END] */
  }

  onChangeVersion() {
    this.getExtremeWorkLink();
  }

  async getKbnSkns(nameKbn: string, sknTitle: string, kbnCd?: string) {
    const response = await this.commonService.getKbnSkns(sknTitle, kbnCd);
    if (response) {
      let data = response.filter((e: any) => e.isDisabled == 0);
      data = data.sort((a: any, b: any) => (a.num > b.num ? 1 : -1));
      this.$set(this, nameKbn, [...data]);
    } else {
      this.$set(this, nameKbn, []);
    }
  }

  getKbnList() {
    const arr: any = [];
    arr.push(
      this.getKbnSkns("jidoushaShubetsuList", "skn_jidousha_shubetsu", "7101")
    );
    this.kbnTitles.forEach((item: any) => {
      arr.push(this.getKbnSkns(item.listNm, item.kbn));
    });
  }

  initConditionList() {
    this.tempCondition = {
      jidoushaShubetsu: 0,
      youtoKbn: this.youtoList.map((e: any) => e.kbnKey),
      kudouKbn: this.kudouList.map((e: any) => e.kbnKey),
      fuelKbn: this.fuelList.map((e: any) => e.kbnKey),
      transmissionKbn: this.shiftList.map((e: any) => e.kbnKey),
      brakeKbn: this.brakeList.map((e: any) => e.kbnKey)
    };
    this.selectedJidousha = this.jidoushaShubetsuList.map((e: any) => e.kbnKey);
  }

  getCateId(cateIndex: any) {
    if (Object.keys(this.currentInspectData).length > 0) {
      if (cateIndex != null) {
        return (this.tempCate.sknInspectCategoryParentId = this.currentInspectData.categories[
          cateIndex
        ].sknInspectCategoryId);
      } else {
        return this.currentInspectData.sknInspectTypeId;
      }
    } else if (this.currentTypeIndex == 3) {
      return 80;
    }
    return null;
  }

  onShowCategoryDialog(parentCateIndex: any = null) {
    this.tempCate = {
      sknInspectCategoryParentId: this.getCateId(parentCateIndex),
      sknInspectCategoryName: "",
      sknInspectType: this.currentTypeIndex == 3 ? 6: this.currentTypeIndex,
      sknHanyouSeibiVersion: this.hanyouSeibiVersion || 1
      , osusume: false
    };
    if (parentCateIndex == null) {
      /** 2021-08-30 sh #7382 fix it does not add category. [START] */
      // this.isEdit = false;
      this.isEditCheckOsusume = false;
      /** 2021-08-30 sh #7382 fix it does not add category. [END] */
    } else {
      /** 2021-08-30 sh #7382 fix it does not add category. [START] */
      // this.isEdit = true;
      this.isEditCheckOsusume = true;
      /** 2021-08-30 sh #7382 fix it does not add category. [END] */
    }
    this.showCateDialog = true;
  }

  async onAddCategory() {
    if (this.isEdit) {
      this.updateCategory();
    } else {
    if (this.tempCate.sknInspectCategoryName) {
      /** 2021-08-12 sh #7329 add loading and re-get after add. [START] */
      this.$set(this, "loadingCd", true);
      /** 2021-08-12 sh #7329 add loading and re-get after add. [END] */
      const res: any = await this.service.addCategory(this.tempCate);
      if (res.sknInspectCategoryId) {
        /** 2021-08-12 sh #7329 add loading and re-get after add. [START] */
        /** change to re-get from API. */
        // this.tempCate.sknInspectCategoryId = res.sknInspectCategoryId;
        // const cate = this.utils.deepCopy(this.tempCate);
        // cate.sknInspectCategoryNm = cate.sknInspectCategoryName;
        // delete cate.sknInspectCategoryName;
        // if (
        //   cate.sknInspectCategoryParentId ==
        //   this.currentInspectData.sknInspectTypeId
        // ) {
        //   cate.subItems = [];
        //   const categories = this.currentInspectData.categories;
        //   categories.push(cate);
        //   this.$set(this.currentInspectData, "categories", categories);
        // } else {
        //   cate.inspectWorks = [];
        //   const categories = this.currentInspectData.categories[
        //     this.currentCateIndex
        //   ].subItems;
        //   categories.push(cate);
        //   this.$set(
        //     this.currentInspectData.categories[this.currentCateIndex],
        //     "subItems",
        //     categories
        //   );
        // }
        /** 2021-08-30 sh #7382 fix it does not add category. [START] */
        // this.showCateDialog = false;
        this.onCloseCateDialog();
        /** 2021-08-30 sh #7382 fix it does not add category. [END] */
        this.$set(this, "loadingCd", false);
        this.$message.success("カテゴリを登録しました。再読み込みします。しばらくお待ちください。");
        this.getExtremeWorkLink();
        return ;
        /** 2021-08-12 sh #7329 add loading and re-get after add. [END] */
      } else {
        this.$message.error("エラー");
      }
      /** 2021-08-12 sh #7329 add loading and re-get after add. [START] */
      // this.showCateDialog = false;
      this.onCloseCateDialog();
      /** 2021-08-12 sh #7329 add loading and re-get after add. [END] */
    }
    }
  }

  initTempInspect(cateId = 0, inspectCd = "") {
    const tempInspect = {
      inspectCd,
      description: "",
      sknInspectCategoryId: cateId,
      sknInspectCommentId: null,
      isHoanKijun: 0,
      sknHanyouSeibiVersion: this.hanyouSeibiVersion,
      displayOrder: 0,
      isNumber: 0,
      isQuantity: 0,
      branchId: 1,
      inspecCondionList: []
    };
    this.$set(this, "tempInspect", tempInspect);
  }
  async onShowInspectDialog(subCate: any) {
    this.showInspectDialog = true;
    if (this.inspectCommentList.length == 0) {
      const res = await this.inspectCommentService.getInspectComment();
      if (res) {
        this.inspectCommentList = res;
      }
    }
    this.$set(this, "loadingCd", true);
    const inspecCd = await this.service.getInspectCd(
      this.hanyouSeibiVersion,
      this.currentTypeIndex
    );
    this.$set(this, "loadingCd", false);
    this.initTempInspect(subCate.sknInspectCategoryId, inspecCd);
    this.initConditionList();
    this.tempSubItem = subCate;
  }

  async onAddInspect() {
    if (
      this.tempInspect.description &&
      this.tempInspect.inspectCd &&
      this.selectedJidousha.length > 0 &&
      this.tempCondition.youtoKbn.length > 0 &&
      this.tempCondition.kudouKbn.length > 0 &&
      this.tempCondition.fuelKbn.length > 0 &&
      this.tempCondition.transmissionKbn.length > 0 &&
      this.tempCondition.brakeKbn.length > 0
    ) {
      const conditionList: InspectCondition[] = this.selectedJidousha.map(
        (e: any) => {
          const item: InspectCondition = {
            ...this.tempCondition,
            jidoushaShubetsu: e
          };
          return item;
        }
      );
      /** 2021-08-03 sh #7329 add loading [START] */
      this.$set(this, "loadingCd", true);
      /** 2021-08-03 sh #7329 add loading [END] */
      this.tempInspect.inspecCondionList = conditionList;
      const res = await this.service.addInspection(this.tempInspect);
      if (res.status == 200) {
        this.showInspectDialog = false;
        /** 2021-08-03 sh #7329 add loading [START] */
        // const work = this.utils.deepCopy(this.tempInspect);
        // work.inspectNm = work.description;
        // delete work.description;
        // work.shakenWork = [];
        // this.tempSubItem.inspectWorks.push(work);
        this.tempSubItem = null;
        this.$set(this, "loadingCd", false);
        this.$message.success("登録しました。再読み込みします。しばらくお待ちください。");
        this.getExtremeWorkLink();
        /** 2021-08-03 sh #7329 add loading [END] */
      } else {
        this.$message.error("エラー");
        /** 2021-08-03 sh #7329 add loading [START] */
        this.$set(this, "loadingCd", false);
        /** 2021-08-03 sh #7329 add loading [END] */
      }
    }
  }

  initTempSeibi(inspectCd: any = null, workCd = "") {
    const seibiKousuuItem = this.jidoushaShubetsuList.map((e: any) => {
      return { kousuu: 0, jidoushaShubetsu: e.kbnKey, kouchinZn: null };
    });
    const tempSeibi = {
      inspectCd: inspectCd,
      workCd,
      sknInspectSeibiTitle: "",
      koukanMeyasuTime: null,
      displayOrder: 0,
      sknHanyouSeibiVersion: this.hanyouSeibiVersion,
      seibiKousuuItem
    };
    this.$set(this, "tempSeibi", tempSeibi);
  }

  async onShowSeibitDialog(e: any, item: any) {
    // e.stopPropagation();
    this.showSeibiDialog = true;
    this.tempInspectWork = item;
    this.$set(this, "loadingCd", true);
    const workCd = await this.service.getWorkCd(this.hanyouSeibiVersion);
    this.$set(this, "loadingCd", false);
    this.initTempSeibi(item.inspectCd, workCd);
  }

  async onAddSeibi() {
    if (this.tempSeibi.sknInspectSeibiTitle && this.tempSeibi.workCd) {
      this.showSeibiDialog = false;
      this.isSubCate = false;
      this.tempSeibi.isExtreme = 0;
      /** 2021-08-19 sh #7354 it gets master after add seibi. [START] */
      this.$set(this, "loadingCd", true);
      /** 2021-08-19 sh #7354 it gets master after add seibi. [END] */
      const res = await this.service.addSeibi(this.tempSeibi);
      if (res.status == 200) {
        /** 2021-08-19 sh #7354 it gets master after add seibi. [START] */
        // this.tempSeibi.workNm = this.tempSeibi.sknInspectSeibiTitle;
        // const seibiList = this.tempInspectWork.shakenWork;
        // seibiList.push(this.mapShakenWork(this.tempSeibi));
        // this.$set(this.tempInspectWork, "shakenWork", seibiList);
        this.$set(this, "loadingCd", false);
        this.$message.success("登録しました。再読み込みします。しばらくお待ちください。");
        this.getExtremeWorkLink();
        /** 2021-08-19 sh #7354 it gets master after add seibi. [END] */
      } else {
        this.$message.error("エラー");
      }
    }
  }

  editCategory(cate: any) {
    this.tempCate = {
      id: cate.id,
      sknInspectCategoryId: cate.sknInspectCategoryId,
      sknInspectCategoryParentId: this.getCateId(null),
      sknInspectCategoryName: cate.sknInspectCategoryNm,
      sknInspectType: 6,
      sknHanyouSeibiVersion: this.hanyouSeibiVersion || 1,
      dataStateKbn: 1,
      osusume: cate.isOsusume == 1
    };
    this.showCateDialog = true;
    this.isEdit = true;
    /** 2021-08-30 sh #7382 fix it does not add category. [START] */
    this.isEditCheckOsusume = true;
    /** 2021-08-30 sh #7382 fix it does not add category. [END] */
  }

  async updateCategory() {
    const res: any = await this.service.updateCategory(this.tempCate);
    if (res.id) {
      this.currentInspectData.categories = this.currentInspectData.categories.map((element: any) => {
        if (element.id == this.tempCate.id) {
          return { ...element, sknInspectCategoryNm: this.tempCate.sknInspectCategoryName };
        } else {
          return { ...element };
        }
      });
      /** 2021-08-30 sh #7382 fix it does not add category. [START] */
      // this.tempCate = {} as InspectCategory;
      // this.showCateDialog = false;
      // this.isEdit = false;
      this.onCloseCateDialog();
      /** 2021-08-30 sh #7382 fix it does not add category. [END] */
    } else {
      this.$message.error("エラー");
    }
  }

  onConfirmDelete(cate: any) {
    this.tempCate = {
      id: cate.id,
      sknInspectCategoryId: cate.sknInspectCategoryId,
      sknInspectCategoryParentId: this.getCateId(null),
      sknInspectCategoryName: cate.sknInspectCategoryNm,
      sknInspectType: 6,
      sknHanyouSeibiVersion: this.hanyouSeibiVersion || 1,
      dataStateKbn: 9,
      osusume: cate.isOsusume
    };
    this.showConfirmDelete = true;
  }

  onCloseDelete() {
    this.tempCate = {} as InspectCategory;
    this.showConfirmDelete = false;
  }

  async deleteCategory() {
    const res: any = await this.service.updateCategory(this.tempCate);
    if (res.id) {
      /** 2021-08-12 sh #7329 re-get after delete. [START] */
      // const index = this.currentInspectData.categories.findIndex((cate: any) => cate.id == this.tempCate.id);
      // this.currentInspectData.categories.splice(index, 1);
      // this.tempCate = {} as InspectCategory;
      /** 2021-08-12 sh #7329 re-get after delete. [START] */
      this.$message.success("削除しました。");
      // 再読み込みをします。
      this.getExtremeWorkLink();
      this.showConfirmDelete = false;
    } else {
      this.$message.error("エラー");
    }
  }

  changeInspectionJizen(val: any, item: InspectDescription) {
    if (val) {
      if (this.currentTypeIndex!=2) {
        this.addInspection(val, item);
      } else {
        this.addRecommendInspectSeibi(val, item);
      }
    }
  }

  async addInspection(jizenSknInspectCategoryId: number, item: InspectDescription) {
    let inspect = {
      id: item.id
      , inspectCd: item.inspectCd
      , sknInspectCategoryId: 0
      , branchId: 1
      , description: ""
      , displayOrder: 0
      , sknHanyouSeibiVersion: 1
      , jizenSknInspectCategoryId: jizenSknInspectCategoryId,
    };
    /** 2021-08-16 sh #7339 add loading and notification. [START] */
    this.loading = true;
    const res = await this.service.addInspectDescription(inspect);
    this.loading = false;
    /** 2021-08-16 sh #7339 add loading and notification. [END] */
    if (res.status == 200) {
      /** 2021-08-16 sh #7339 add loading and notification. [START] */
      this.$message.success("追加しました。再読み込みします。しばらくお待ちください。");
      /** 2021-08-16 sh #7339 add loading and notification. [END] */
      this.getExtremeWorkLink();
    } else {
      this.$message.error("エラー");
    }
  }

  async addRecommendInspectSeibi(jizenSknInspectCategoryId: number, item: InspectDescription) {
    let inspect = {
      id: item.id
      , inspectCd: item.workCd ? item.workCd: item.id
      , sknInspectCategoryId: 0
      , branchId: 1
      , description: ""
      , displayOrder: 0
      , sknHanyouSeibiVersion: 1
      , jizenSknInspectCategoryId: jizenSknInspectCategoryId,
    };
    /** 2021-08-16 sh #7339 add loading and notification. [START] */
    this.loading = true;
    const res = await this.service.addRecommendInspectSeibi(inspect);
    this.loading = false;
    /** 2021-08-16 sh #7339 add loading and notification. [END] */
    if (res.status == 200) {
      /** 2021-08-16 sh #7339 add loading and notification. [START] */
      this.$message.success("追加しました。再読み込みします。しばらくお待ちください。");
      /** 2021-08-16 sh #7339 add loading and notification. [END] */
      this.getExtremeWorkLink();
    } else {
      this.$message.error("エラー");
    }
  }

  onEnd(index: number) {
    if (this.timerReOrder) {
      clearTimeout(this.timerReOrder);
      this.timerReOrder = null;
    }
    let inspects: any[] = [];
    this.timerReOrder = setTimeout(() => {
      this.currentData[index].inspectWorks.forEach((e: any, i: number) => {
        let item = {
          ...e, displayOrder: i
        };
        if (this.currentData[index].isOsusume) {
          inspects.push({
            id: item.id
            , subDisplayOrder: item.subDisplayOrder
            , displayOrder: item.displayOrder
            , workCd: item.inspectCd
          });
        } else {
          inspects.push({
            id: item.id
            , subDisplayOrder: item.subDisplayOrder
            , displayOrder: item.displayOrder
          });
        }
      });
      if (this.currentData[index].isOsusume) {
        this.service.updateRecommendInspectSeibiOrder(inspects);
      } else {
        this.service.updateInspectDescriptionOrder(inspects);
      }
    }, 1000);
  }

  onSubEnd() {
    let inspects: any[] = [];
    this.timerReOrder = setTimeout(() => {
      this.currentData.forEach((element: any, i: number) => {
        if (element.inspectWorks && element.inspectWorks.length > 0) {
          element.inspectWorks.forEach((inspectWork: any) => {
            let item = {
              ...inspectWork, subDisplayOrder: i
            };
            if (element.isOsusume) {
              inspects.push({
                id: item.id
                , subDisplayOrder: item.subDisplayOrder
                , displayOrder: item.displayOrder
                , workCd: item.inspectCd
              });
            } else {
              inspects.push({
                id: item.id
                , subDisplayOrder: item.subDisplayOrder
                , displayOrder: item.displayOrder
              });
            }
          });
        }
        if (element.isOsusume) {
          this.service.updateRecommendInspectSeibiOrder(inspects);
        } else {
          this.service.updateInspectDescriptionOrder(inspects);
        }
      });
    }, 1000);
  }

  onConfirmDeleteJizen(item: any) {
    this.tempJizenItem = item;
    this.showConfirmDeleteJizen = true;
  }

  async deleteJizenCategory() {
    console.log(this.tempJizenItem);
    if (this.tempJizenItem.inspectCd) {
      const { result, error } = await this.service.deleteMSknInspectDescription(this.tempJizenItem);
      if (result && result.status == 200) {
        this.getExtremeWorkLink();
        this.showConfirmDeleteJizen = false;
      } else {
        this.$message.error("エラー");
      }
    } else {
      const { result, error } = await this.service.deleteMSknRecommendInspectSeibi(this.tempJizenItem);
      if (result && result.status == 200) {
        this.getExtremeWorkLink();
        this.showConfirmDeleteJizen = false;
      } else {
        this.$message.error("エラー");
      }
    }
  }

  onCloseDeleteJizen() {
    this.showConfirmDeleteJizen = false;
  }

  /** 2021-08-03 sh #7329 implements delete [START] */
  onShowConfirmSubCategory(data: any) {
    this.tempSubCategory = {
      categoryId: data.sknInspectCategoryId,
      versionId: data.sknHanyouSeibiVersion
    };
    this.showConfirmDeleteSubCategory = true;
  }
  deleteSubCategory() {
    const promise = this.deleteSubCategoryPM();

    Promise.all([promise]).then((val: any) => {
      if (val) {
        this.$message.success("削除しました。");
        // 再読み込みをします。
        this.getExtremeWorkLink();
      }
      this.tempSubCategory = {};
      this.showConfirmDeleteSubCategory = false;
    },(err: any) => {
      this.tempSubCategory = {};
      this.$message.error("エラー(削除失敗)");
      this.showConfirmDeleteSubCategory = false;
    });
  }
  onCloseConfirmDeleteSubCategory() {
    this.showConfirmDeleteSubCategory = false;
  }
  deleteSubCategoryPM() {
    let promise = new Promise((resolve, reject) => {
      let param = this.utils.deepCopy(this.tempSubCategory);
      this.service.deleteSubCategory(param).then((res: any)  => {
        if (res) {
          if (res && res.result && res.result.status === 200) {
            resolve(res);
          } else {
            reject(res);
          }
        } else {
          reject(res);
        }
      },(err: any) => { reject(); });
    });
    return promise;
  }

  onShowConfirmDeleteInspection(data: any, jizen: any) {
    this.tempInspection = {
      id: data.inspectId,
      inspectCd: data.inspectCd,
      versionId: data.sknHanyouSeibiVersion,
      isCanDelete: data.isCanDelete
    };
    this.isNeedDeleteJizen = false;
    if (jizen && jizen.jizenId) {
      this.isNeedDeleteJizen = true;
      this.tempJizenItem = jizen;
    }
    this.showConfirmDeleteInspection = true;
  }
  deleteInspection() {
    const promise = this.deleteInspectionPM();

    Promise.all([promise]).then((val: any) => {
      if (val) {
        this.$message.success("削除しました。");
        if (this.isNeedDeleteJizen) {
          this.deleteJizenCategory();
          this.isNeedDeleteJizen = false;
        } else {
          // 再読み込みをします。
          this.getExtremeWorkLink();
        }
      }
      this.tempInspection = {};
      this.showConfirmDeleteInspection = false;
    },(err: any) => {
      this.$message.error("エラー(削除失敗)");
      this.isNeedDeleteJizen = false;
      this.showConfirmDeleteInspection = false;
    });
  }
  onCloseConfirmDeleteInspection() {
    this.showConfirmDeleteInspection = false;
  }
  deleteInspectionPM() {
    let promise = new Promise((resolve, reject) => {
      let param = this.utils.deepCopy(this.tempInspection);
      delete param.isCanDelete;
      this.service.deleteInspection(param).then((res: any)  => {
        if (res) {
          if (res && res.result && res.result.status === 200) {
            resolve(res);
          } else {
            reject(res);
          }
        } else {
          reject(res);
        }
      },(err: any) => { reject(); });
    });
    return promise;
  }

  onShowConfirmDeleteMidCategory(cate: any) {
    this.tempMidCategory = {
      categoryId: cate.sknInspectCategoryId,
      versionId: cate.sknHanyouSeibiVersion
    };
    this.showConfirmDeleteMidCategory = true;
  }
  deleteMidCategory() {
    const promise = this.deleteMidCategoryPM();

    Promise.all([promise]).then((val: any) => {
      if (val) {
        this.$message.success("削除しました。");
        // 再読み込みをします。
        this.getExtremeWorkLink();
      }
      this.tempMidCategory = {};
      this.showConfirmDeleteMidCategory = false;
    },(err: any) => {
      this.tempMidCategory = {};
      this.$message.error("エラー(削除失敗)");
      this.showConfirmDeleteMidCategory = false;
    });
  }
  onCloseConfirmDeleteMidCategory() {
    this.showConfirmDeleteMidCategory = false;
  }
  deleteMidCategoryPM() {
    let promise = new Promise((resolve, reject) => {
      let param = this.utils.deepCopy(this.tempMidCategory);
      this.service.deleteMidCategory(param).then((res: any)  => {
        if (res) {
          if (res && res.result && res.result.status === 200) {
            resolve(res);
          } else {
            reject(res);
          }
        } else {
          reject(res);
        }
      },(err: any) => { reject(); });
    });
    return promise;
  }
  /** 2021-08-03 sh #7329 implements delete [END] */
  changeAllInspectionJizen(val: any, subCate: any) {
    if (val) {
      if (subCate.inspectWorks && subCate.inspectWorks.length > 0) {
        subCate.inspectWorks.forEach((item: any) => {
          this.addRecommendInspectSeibi(val, item);
        });
      }
    }
  }

  async getJizenVal() {
    this.loading = true;
    const { result } = await this.service.getJizenVal();
    this.loading = false;
    if (result && result.data) {
      this.jizenVal = result.data ? (result.data == '1' ? true: false): false;
    }
  }
  changeWorkAdd(e: any, item: any, data: any) {
    if (this.workAdd == 2) {
      this.onShowSeibitDialog(e, item);
    } else if (this.workAdd == 1) {
      this.isSubCate = true;
      data.extremeWork = [];
      this.onEdit(data);
    }
  }
  onCloseSeibiDialog() {
    this.workAdd = 0;
    this.isSubCate = false;
    this.showSeibiDialog = false;
  }
  onExtremeWorksSave() {
    let extremeWorks: any = [];
    let deletedExtremeWorks: any = [];
    if (this.workEditing.extremeWork.length > 0) {
      deletedExtremeWorks = this.workEditing.extremeWork
        .filter(
          (extreme: any) => this.listSelected.indexOf(extreme.workCd) === -1
        )
        .map((e: any) => {
          return { workCd: e.workCd };
        });
    }
    if (this.listSelected.length > 0) {
      extremeWorks = this.extremeWorkList
        .filter(
          (extreme: any) => this.listSelected.indexOf(extreme.workCd) > -1
        )
        .map((e: any) => {
          return { workCd: e.workCd };
        });
    }
    let promiseSave = null;
    let promiseDel = null;
    if (extremeWorks.length > 0) {
      let datas: any = [];
      const seibiKousuuItem = this.jidoushaShubetsuList.map((e: any) => {
        return { kousuu: 0, jidoushaShubetsu: e.kbnKey, kouchinZn: null };
      });
      extremeWorks.forEach((e: any) => {
        let data = {
          inspectCd: this.workEditing.inspectCd,
          workCd: 0,
          sknInspectSeibiTitle: "",
          koukanMeyasuTime: null,
          displayOrder: 0,
          sknHanyouSeibiVersion: this.hanyouSeibiVersion,
          seibiKousuuItem,
          isExtreme: 1,
          extremeWorkCd: e.workCd
        };
        datas.push(data);
      });
      promiseSave = this.service.addExtremeSeibi(datas);
    }
    if (deletedExtremeWorks.length > 0) {
      const obj: any = {
        shakenWorkId: this.workEditing.workId,
        sknHanyouSeibiVersionId: this.hanyouSeibiVersion, // 2022-11-21 sh #7846(BQR965) add version.
        deletedExtremeWorks
      };
      promiseDel = this.service.deleteExtremeWorkLink(obj);
    }

    if (promiseSave && promiseDel) {
      Promise.all([promiseSave, promiseDel]).then((res: any) => {
        if (res && res.result && res.result.status == 200) {
          this.getExtremeWorkLink();
        } else {
          this.$message.error(MESSAGE.SystemError);
        }
      });
    } else {
      if (promiseSave) {
        promiseSave.then(res => {
          this.onAfterExtreme(res);
        });
      } else if (promiseDel) {
        promiseDel.then(res => {
          this.onAfterExtreme(res);
        });
      }
    }
    this.showEditDialog = false;
    /** 2023-01-23 sh #7846(BQR965) fix bug. add dummy option. [START] */
    this.workAdd=0;
    /** 2023-01-23 sh #7846(BQR965) fix bug. add dummy option. [END] */
  }
  onShowConfirmExtremeWork(data: any) {
    if (!data.shakenWorkId) {
      this.tempInspectSeibiLink = {
        id: data.inspectSeibiLinkId
      };
    } else {
      let deletedExtremeWorks = [{ workCd: data.workCd }];
      this.tempInspectSeibiLink = {
        shakenWorkId: data.shakenWorkId,
        sknHanyouSeibiVersionId: this.hanyouSeibiVersion, // 2022-11-21 sh #7846(BQR965) add version.
        deletedExtremeWorks
      };
    }
    this.showConfirmDeletExtremeWork = true;
  }
  deleteExtremeWork() {
    let promise = null;
    if (this.tempInspectSeibiLink.id) {
      promise = this.deleteExtremeWorkPM();
    } else {
      promise = this.service.deleteExtremeWorkLink(this.tempInspectSeibiLink);
    }

    Promise.all([promise]).then((val: any) => {
      if (val) {
        this.$message.success("削除しました。");
        // 再読み込みをします。
        this.getExtremeWorkLink();
      }
      this.tempInspectSeibiLink = {};
      this.showConfirmDeletExtremeWork = false;
    },(err: any) => {
      this.tempInspectSeibiLink = {};
      this.$message.error("エラー(削除失敗)");
      this.showConfirmDeletExtremeWork = false;
    });
  }
  onCloseConfirmDeleteExtremeWork() {
    this.showConfirmDeletExtremeWork = false;
  }
  deleteExtremeWorkPM() {
    let promise = new Promise((resolve, reject) => {
      let param = this.utils.deepCopy(this.tempInspectSeibiLink);
      this.service.deleteInspectSeibiLink(param).then((res: any)  => {
        if (res) {
          if (res && res.result && res.result.status === 200) {
            resolve(res);
          } else {
            reject(res);
          }
        } else {
          reject(res);
        }
      },(err: any) => { reject(); });
    });
    return promise;
  }
  /** 2021-08-30 sh #7382 fix it does not add category. [START] */
  get isDisableOsusume() {
    return this.isEditCheckOsusume;
  }

  onCloseCateDialog() {
    this.tempCate = {} as InspectCategory;
    this.showCateDialog=false;
    this.isEditCheckOsusume = false;
    this.isEdit = false;
  }
  /** 2021-08-30 sh #7382 fix it does not add category. [END] */
  onConfirmDeleteJizenAll(items: any[]) {
    this.tempJizenItems = items;
    this.showConfirmDeleteJizenAll = true;
  }

  deleteJizenAll() {
    let promise = null;
    this.tempJizenItems.forEach((item: any) => {
      promise = this.deleteJizenCategoryAll(item);
    });
    Promise.all([promise]).then((val: any) => {
      if (val) {
        this.$message.success("削除しました。");
        // 再読み込みをします。
        this.getExtremeWorkLink();
      }
      this.tempJizenItems = [];
      this.showConfirmDeleteJizenAll = false;
    },(err: any) => {
      this.tempJizenItems = [];
      this.$message.error("エラー(削除失敗)");
      this.showConfirmDeleteJizenAll = false;
    });
  }

  async deleteJizenCategoryAll(item: any) {
    if (item.inspectCd) {
      const { result, error } = await this.service.deleteMSknInspectDescription(item);
      if (result && result.status == 200) {
      } else {
        this.$message.error("エラー");
      }
    } else {
      const { result, error } = await this.service.deleteMSknRecommendInspectSeibi(item);
      if (result && result.status == 200) {
      } else {
        this.$message.error("エラー");
      }
    }
  }
}
